import * as React from "react";
import { FramingRow, FramingMode } from "@/types/contentFraming";
import ContentFramingDynamic from "./ContentFramingDynamic";

interface KeyTakeAwaysProps {
  rows: FramingRow[];
  placeholderOptions: { value: string; label: string }[];
  onToggle: (id: string, enabled: boolean) => void;
  onSelectionChange: (id: string, value: string) => void;
  onInputTextChange: (id: string, value: string) => void;
  onModeChange?: (id: string, mode: FramingMode) => void;
  onUpdateFieldsFromShape?: (id: string, shapeId: string) => void;
  onHoverShape?: (shapeId: string | null) => void;
}

export const KeyTakeAways: React.FC<KeyTakeAwaysProps> = ({
  rows,
  placeholderOptions,
  onToggle,
  onSelectionChange,
  onInputTextChange,
  onModeChange,
  onUpdateFieldsFromShape,
  onHoverShape,
}) => {

  const [showKeyTakeAways ] = React.useState(rows[6].enabled ? true : false);
  return (
    <>
     
     
        <div className="flex flex-col gap-2">
          {showKeyTakeAways ? (
          <p>
          I have drafted updated summary points for your slide to account for the latest analysis. Let me know if you would like me to make these changes to the Key Take-ways placeholder in your PowerPoint.
          </p>): (
            <p>
              I have drafted updated summary points for your slide to account for the latest analysis. <b> I could not find an appropriate placeholder to include the text.</b> If you would like to include this text, please  select an appropriate placeholder.
            </p>
          )}
        </div>

        <div className="flex flex-col items-start justify-between mt-4">
            <ContentFramingDynamic
              row={rows[6]}
              placeholderOptions={placeholderOptions}
              onToggle={onToggle}
              onSelectionChange={onSelectionChange}
              onInputTextChange={onInputTextChange}
              onModeChange={onModeChange}
              onUpdateFieldsFromShape={onUpdateFieldsFromShape}
              onHoverShape={onHoverShape}
              keyTakeAways={true}
            />
        </div>
    </>
  );
};

export default KeyTakeAways;


